module.exports = __webpack_public_path__ + "static/media/11-10.08b5efda.mp3";